import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { Security as SecurityIcon, Add as AddIcon } from "@mui/icons-material";
import { useTheme } from "@mui/material";

const SystemsEmptyState = ({ onAddSystem }) => {
  const theme = useTheme();

  return (
    <Box sx={{
      textAlign: "center",
      py: 8,
      px: 4,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "400px",
    }}>
      <SecurityIcon
        sx={{
          fontSize: 48,
          color: theme.customColors.icons.disabled,
          mb: 3,
        }}
      />
      <Typography
        variant="h5"
        color="textSecondary"
        sx={{ mb: 2, fontWeight: 600 }}
      >
        No systems found
      </Typography>
      <Typography
        variant="body2"
        color="textSecondary"
        sx={{ mb: 4, maxWidth: 400, lineHeight: 1.5 }}
      >
        No systems are currently registered. Start building your system inventory by adding systems manually.
      </Typography>
      <Button
        variant="contained"
        startIcon={<AddIcon sx={{ fontSize: 16 }} />}
        onClick={onAddSystem}
        sx={{
          bgcolor: "#1976d2",
          color: "white",
          fontWeight: 500,
          borderRadius: "8px",
          textTransform: "none",
          fontSize: "14px",
          px: 2,
          py: 1,
          "&:hover": {
            bgcolor: "#1565c0",
          },
        }}
        size="large"
      >
        Add New System
      </Button>
    </Box>
  );
};

export default SystemsEmptyState;

